import ShareCiphers from "./Ciphers";
import ShareFolders from "./Folders";
import Filter from "./Filter";

const sharedWithMeComponents = {
  ShareCiphers,
  ShareFolders,
  Filter
}

export default sharedWithMeComponents;